import { useState } from 'react'
import InstructorName from '../../components/instructorProfile/instructorName/InstructorName'
import { InstructorProfileData } from '../../server/types'
import InstructorProfileDetails from '../../components/instructorProfile/instructorProfileDetails/InstructorProfileDetails'
import InstructorProfileMiniDetails from '../../components/instructorProfile/instructorProfileMiniDetails/InstructorProfileMiniDetails'
import { getSchoolString } from '../../utils/RetrieveStrings'
import { getProfilePicPath, getProfilePicPathArr } from '../../constants/instructorConstants'
// import { INSTRUCTOR_GENDERS } from '../../constants/searchConstants'

interface InstructopProfileHeroProps {
	profileData: InstructorProfileData
}

function InstructopProfileHero({profileData}: InstructopProfileHeroProps) {
	const [selectedProfileIndex, setSelectedProfileIndex] = useState<number>(0)

	/**
	 * Handler for image being selected in the profile details section which will be used to change the Instructor profile main image 
	 * @param imgIndex Index of image being selected
	 */
	const profileImgSelected = (imgIndex: number) => {
		// TODO: change how images are defined so switching images doesn't load the image again
		setSelectedProfileIndex(imgIndex)
	}

	const calculateAge = (dobStr: string) => {
		let dob: Date = new Date(dobStr)
		return Math.floor((Date.now() - dob.getTime()) / 31556952000).toString()
	}

	// const getGender = () => {
	// 	if (profileData.gender) {
	// 		return INSTRUCTOR_GENDERS[profileData.gender] ? INSTRUCTOR_GENDERS[profileData.gender] : ''
	// 	} else {
	// 		return undefined
	// 	}
	// }

	return (
		<div className='section-content'>
			<InstructorName name={profileData.name} />
			<div className='instructor-profile-details-section'>
				<div className='instructor-profile-main-img-wrap'>
					<img
						src={getProfilePicPath(profileData.profile_pics, selectedProfileIndex)}
						className='instructor-profile-main-img'
						alt='Instructor Profile'
					/>
				</div>
				<InstructorProfileDetails
					// imgs={profileData.profile_pics}
					imgs={getProfilePicPathArr(profileData.profile_pics)}
					price={profileData.price}
					groupSizes={profileData.group_size}
					choosenImgIndex={selectedProfileIndex}
					imgSelected={profileImgSelected}
					instructorLevel={profileData.level}
					id={profileData.id}
				/>
			</div>
			<InstructorProfileMiniDetails
				// imgUrl='/imgs/temp/profile_thumbnails/profile-00000.png'
				imgUrl={getProfilePicPath(profileData.profile_pics, 0)}
				name={profileData.name}
				activity={profileData.activity}
				schoolName={getSchoolString(profileData.school)}
				level={profileData.level}
				age={profileData.dob ? calculateAge(profileData.dob) : undefined}
				// gender={getGender()}
			/>
		</div>
	)
}

export default InstructopProfileHero
